<template>
  <el-dialog :visible="visible" @close="$emit('update:visible', false)"
             :before-close="beforeClose" class="dialog-w80">
    <h2 class="text-center my-0">{{title}}</h2>

    <el-form :model="form" :rules="rules" ref="form" :validate-on-rule-change="false">
      <div class="row mt-5">
        <div class="col-12">
          <el-form-item prop="is_available">
            <span class="mr-2">Просмотр деталей тренировки:</span>
            <el-switch :value="form.is_available" @change="form.is_available = !form.is_available"
                       active-text="Вкл."
                       inactive-text="Выкл." />
          </el-form-item>
        </div>

        <div class="col-12 col-sm-4 pr-sm-0">
          <el-form-item prop="device_id">
            <el-select class="w-100" v-model="form.device_id" @change="$refs.form.clearValidate()"
                       placeholder=""
                       filterable
                       :loading="fetchProgressDevices">
              <el-option v-for="option in filteredDevices" :key="option.id" :label="option.name" :value="option.id" :disabled="!option.active"  />
            </el-select>
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.device_id) }">Устройство</span>
          </el-form-item>
        </div>
        <div class="d-none d-sm-block col-sm-8" />

        <div class="col-12 col-sm-8 pr-sm-0">
          <el-form-item prop="title">
            <el-input v-model="form.title" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.title) }">Название</span>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-4">
          <el-form-item prop="calories">
            <el-input :value="form.calories" @input="form.calories = replaceNumber($event)"/>
            <span class="floating-span" :class="{ 'floating-span_active': replaceNumber(form.calories) }">Количество калорий</span>
          </el-form-item>
        </div>

        <div class="col-12 col-sm-6 pr-sm-0">
          <el-form-item prop="video_link">
            <el-input v-model="form.video_link" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.video_link) }">Ссылка на видеозапись</span>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-3 pr-sm-0">
          <el-form-item prop="type">
            <el-select class="w-100"
                       filterable
                       :loading="false"
                       @change="onChangeType"
                       :value="form.type"
                       ref="typeRef"
                       placeholder="">
              <el-option
                v-for="option in workoutTypes"
                :key="option.type"
                :label="option.title"
                :value="option.type">
              </el-option>
            </el-select>
            <span class="floating-span"
                :class="{'floating-span_active': $notEmpty(form.type
        ) || $notEmpty($refs.typeRef && $refs.typeRef.query)}">
              Выберите тип
            </span>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-3">
          <el-form-item prop="duration">
            <el-input :value="form.duration" @input="form.duration = replaceNumber($event)"/>
            <span class="floating-span" :class="{ 'floating-span_active': replaceNumber(form.duration) }">Длительность, мин</span>
          </el-form-item>
        </div>

        <div class="col-12">
          <el-form-item prop="description">
            <el-input type="textarea"
                      :rows="4"
                      maxlength="500"
                      show-word-limit
                      v-model="form.description"
                      resize="none"/>
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.description) }">Описание</span>
          </el-form-item>
        </div>

        <div class="col-12 col-sm-4 pr-sm-0">
          <el-form-item prop="levelTags">
            <el-select class="w-100" v-model="form.levelTags" @change="$refs.form.clearValidate()"
                       placeholder=""
                       filterable multiple
                       :loading="fetchProgressTags">
              <el-option v-for="option in levelTags" :key="option.id" :label="option.title" :value="option.id" />
            </el-select>
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.levelTags) }">Хештеги-уровни</span>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-4 pr-sm-0">
          <el-form-item prop="purposeTags">
            <el-select class="w-100" v-model="form.purposeTags" @change="$refs.form.clearValidate()"
                       placeholder=""
                       filterable multiple
                       :loading="fetchProgressTags">
              <el-option v-for="option in purposeTags" :key="option.id" :label="option.title" :value="option.id" />
            </el-select>
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.purposeTags) }">Хештеги-цели</span>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-4">
          <el-form-item prop="otherTags">
            <el-select class="w-100" v-model="form.otherTags" @change="$refs.form.clearValidate()"
                       placeholder=""
                       filterable multiple
                       :loading="fetchProgressTags">
              <el-option v-for="option in otherTags" :key="option.id" :label="option.title" :value="option.id" />
            </el-select>
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.otherTags) }">Хештеги-общие</span>
          </el-form-item>
        </div>

        <div class="col-12 col-sm-6 pr-sm-0">
          <div class="text-small mb-1">Изображение</div>
          <el-form-item prop="picture_title">
            <el-upload ref="upload_picture_title" class="w-100" drag action="/" accept="image/*" :show-file-list="false" :auto-upload="false"
                       :on-change="onChangePictureUrl">
              <img v-if="form.picture_url" :src="form.picture_url" class="loaded-image">
              <template v-else>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Перетащите файл или <em>нажмите для загрузки</em>
                </div>
              </template>
              <div class="text-small text-danger" slot="tip">Текущее изображение удаляется и заменяется новым</div>
            </el-upload>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-6">
          <div class="text-small mb-1">Карта нагрузки</div>
          <el-form-item prop="graphic_title">
            <el-upload ref="upload_graphic_title" class="w-100" drag action="/" accept="image/*" :show-file-list="false" :auto-upload="false"
                       :on-change="onChangeGraphicUrl">
            <img v-if="form.graphic_url" :src="form.graphic_url" class="loaded-image">
              <template v-else>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Перетащите файл или <em>нажмите для загрузки</em></div>
              </template>
              <div class="text-small text-danger" slot="tip">Текущее изображение удаляется и заменяется новым</div>
            </el-upload>
          </el-form-item>
        </div>

        <template v-if="form.type === WORKOUT_TYPES.ROUTE">
          <div class="col-12 col-sm-6 pr-sm-0">
            <div class="text-small mb-1">Изображения для времени маршрутов (6 шт)</div>
            <el-form-item prop="storyboard">
              <el-upload ref="upload_storyboard" class="w-100" drag multiple :limit="picLimit"
                         :disabled="countStoryboardPic >= picLimit"
                         action="/" accept="image/*" :show-file-list="false" :auto-upload="false"
                         :on-change="onChangeSixPic"  :on-exceed="onErrorChangeSixPic">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Перетащите файл или <em>нажмите для загрузки</em>
                  <div>Загружено {{ countStoryboardPic }} из 6 изображений</div>
                  <!--                    <div class="text-secondary text-small">Формат JPG или PNG, объём не более 10 Мб.</div>-->
                </div>
                <div class="text-small text-danger" slot="tip">Текущее изображение удаляется и заменяется новым</div>
              </el-upload>
            </el-form-item>
          </div>
          <div class="col-12 col-sm-6 pr-sm-0 mt-3">
            <div class="six-picture">
              <div v-for="(item, ind) in formatStoryboard" :key="ind" class="six-picture-item">
                <div v-if="item.fileName && item.preview" :style="{backgroundImage: `url(${item.preview})`}" class="six-picture-item__image">
                  <i v-if="item.fileName" class="six-picture-item__image-close el-icon-circle-close" @click="onRemovePic(item)" />
                </div>
                <div v-else class="six-picture-item__image" />
                <div class="six-picture-item__title">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </el-form>

    <div class="row mt-4">
      <div class="col-12 text-right">
        <template v-if="item">
          <el-button v-if="item.is_visible" type="danger"
                    :loading="actionProgress"
                    @click="changeVisibility({id: item.id, data: {visibility: false }})">
            Деактивировать
          </el-button>

          <el-button v-else type="success" :loading="actionProgress"
                     @click="changeVisibility({id: item.id, data: {visibility: true }})">
            Активировать
          </el-button>
        </template>
        <el-button type="primary" :loading="actionProgress" @click="onSubmit">{{submitBtnText}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { replaceNumber } from '@/commons/helpers';
import { MESSAGES } from '@/commons/constants/errorMessages';
import activeStatuses from '@/commons/constants/activeStatuses';
import { TAG_TYPES } from '@/commons/constants/tagTypes';
import { WORKOUT_TYPES } from '@/commons/constants/workoutTypes';

const defaultStoryboard = [
  {
    code: '5',
    title: '5 мин',
    fileName: '',
    preview: '',
  },
  {
    code: '15',
    title: '15 мин',
    fileName: '',
    preview: '',
  },
  {
    code: '30',
    title: '30 мин',
    fileName: '',
    preview: '',
  },
  {
    code: '45',
    title: '45 мин',
    fileName: '',
    preview: '',
  },
  {
    code: '60',
    title: '60 мин',
    fileName: '',
    preview: '',
  },
  {
    code: 'infinity',
    title: '∞',
    fileName: '',
    preview: '',
  },
];

const initialForm = () => ({
  title: '',
  calories: null,
  type: '',
  video_link: '',
  duration: null,
  description: '',
  device_id: null,
  levelTags: [],
  purposeTags: [],
  otherTags: [],
  picture_title: '',
  picture_url: '',
  graphic_title: '',
  graphic_url: '',
  is_available: false,
  storyboard: new Array(6).fill(null).map(() => ({ fillName: '', preview: '' })),
});

export default {
  props: {
    visible: Boolean,
  },

  data() {
    const tagsValidator = (rule, value, callback) => ([...this.form.levelTags, ...this.form.purposeTags, ...this.form.otherTags].length
      ? callback() : callback(new Error(MESSAGES.REQUIRED)));

    return {
      form: initialForm(),
      activeStatuses,
      MESSAGES,
      WORKOUT_TYPES,
      tagsValidator,
      picLimit: 6,
    };
  },
  created() {
    if (!this.workoutTypes.length) {
      this.fetchWorkoutTypes();
    }
    if (!this.tags.length) {
      this.fetchTags();
    }
    if (!this.devices.length) {
      this.fetchDevices();
    }
    this.fillForm();
  },

  computed: {
    ...mapGetters({
      item: 'workouts/item',
      actionProgress: 'workouts/actionProgress',
      workoutTypes: 'workoutTypes/items',
      fetchProgressWorkoutTypes: 'workoutTypes/fetchProgress',
      fetchProgressTags: 'tags/fetchProgress',
      tags: 'tags/items',
      levelTags: 'tags/levelTags',
      fetchProgressDevices: 'devices/fetchProgress',
      devices: 'devices/items',
      purposeTags: 'tags/purposeTags',
      otherTags: 'tags/otherTags',
      getItemByFileName: 'files/getItemByFileName',
    }),
    rules() {
      const requiredRule = [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }];
      const tagsRule = [{ validator: this.tagsValidator, trigger: 'change' }];

      let rules = {
        title: requiredRule,
        type: requiredRule,
        video_link: requiredRule,
        description: requiredRule,
        calories: requiredRule,
        duration: requiredRule,
        picture_title: requiredRule,
        device_id: requiredRule,
        levelTags: tagsRule,
        purposeTags: tagsRule,
        otherTags: tagsRule,
      };
      if (this.form.type === WORKOUT_TYPES.ROUTE) {
        rules = {
          title: requiredRule,
          type: requiredRule,
          video_link: requiredRule,
          duration: requiredRule,
          picture_title: requiredRule,
        };
      }
      return rules;
    },
    isEditMode() {
      return !!this.item?.id;
    },
    title() {
      return this.isEditMode ? 'Редактировать тренировку' : 'Новая тренировка';
    },
    submitBtnText() {
      return this.isEditMode ? 'Сохранить тренировку' : 'Создать тренировку';
    },
    countStoryboardPic() {
      return this.formatStoryboard.filter((x) => x.fileName).length;
    },
    formatStoryboard() {
      return this.form.storyboard.map((s, i) => ({ ...defaultStoryboard[i], ...s }));
    },
    filteredDevices() {
      return this.devices.filter((x) => x.active || this.item?.device?.id === x.id);
    },
  },

  methods: {
    ...mapMutations({
      addNotifyErrors: 'notifications/addNotifyErrors',
    }),
    ...mapActions({
      createItem: 'workouts/createItem',
      updateItem: 'workouts/updateItem',
      changeVisibility: 'workouts/changeVisibility',
      updateImg: 'workouts/updateImg',
      uploadFile: 'files/uploadFile',
      fetchWorkoutTypes: 'workoutTypes/fetchItems',
      fetchTags: 'tags/fetchItems',
      fetchDevices: 'devices/fetchItems',
      fetchItem: 'workouts/fetchItem',
      setItemId: 'workouts/setItemId',
    }),
    replaceNumber,
    beforeClose(done) {
      if (!this.actionProgress) {
        done();
      }
    },
    fillForm() {
      if (this.item) {
        Object.keys(this.form).forEach((key) => {
          switch (key) {
            case 'levelTags': this.form[key] = this.item.tags.filter((it) => it.type === TAG_TYPES.LEVEL).map((t) => t.id); break;
            case 'purposeTags': this.form[key] = this.item.tags.filter((it) => it.type === TAG_TYPES.PURPOSE).map((t) => t.id); break;
            case 'otherTags': this.form[key] = this.item.tags.filter((it) => it.type === TAG_TYPES.OTHER).map((t) => t.id); break;
            case 'device_id': this.form[key] = this.item.device?.id || null; break;
            case 'calories': this.form[key] = this.item[key].toString(); break;
            case 'duration': this.form[key] = this.item[key].toString(); break;
            case 'storyboard': {
              if (this.item[key]) {
                const storyboard = this.item[key];
                this.form[key] = this.formatStoryboard
                  .map((s) => ({ fileName: storyboard[s.code] || '', preview: storyboard[`${s.code}_preview`] || '' }));
              } else {
                this.form[key] = initialForm().storyboard;
              }
              break;
            }
            default: this.form[key] = this.item[key];
          }
        });
      } else {
        this.form = initialForm();
      }
    },
    onChangeType(item) {
      this.$refs.form.clearValidate();
      this.form.type = item;
    },
    onChangePictureUrl(file) {
      this.updateImg({ type: 'title', file }).then((resp) => {
        this.form.picture_title = resp.picture_title;
        this.form.picture_url = resp.picture_url;
      });
      // this.form.picture_url = 'https://ymgch-dev.bsl.dev/media/default/workout.jpg';
    },
    onChangeGraphicUrl(file) {
      this.updateImg({ type: 'graphic', file }).then((resp) => {
        this.form.graphic_title = resp.graphic_title;
        this.form.graphic_url = resp.graphic_url;
      });
      // this.form.graphic_url = 'https://ymgch-dev.bsl.dev/media/default/workout.jpg';
    },
    async onChangeSixPic(file) {
      this.$refs.upload_storyboard?.clearFiles();
      if (this.countStoryboardPic >= this.picLimit) {
        return;
      }
      const formData = new FormData();
      formData.append('image', file.raw);
      const resp = await this.uploadFile({ formData, bucket: 'workoutpics' });

      const indEmpty = this.form.storyboard.findIndex((x) => !x.fileName);
      if (indEmpty > -1) {
        this.form.storyboard[indEmpty].fileName = resp.filename;
        this.form.storyboard[indEmpty].preview = resp.preview;
      }
    },
    onErrorChangeSixPic() {
      this.addNotifyErrors([`Лимит для загрузки ${this.countStoryboardPic} изображений}`]);
    },
    onRemovePic(item) {
      const indEmpty = this.form.storyboard.findIndex((x) => x.fileName === item.fileName);

      if (indEmpty > -1) {
        this.form.storyboard[indEmpty].fileName = '';
        this.form.storyboard[indEmpty].preview = '';
      }
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const id = this.item?.id;
          const tags = [...this.tags.filter((t) => [...this.form.levelTags, ...this.form.purposeTags, ...this.form.otherTags]
            .some((tId) => tId === t.id))];
          const data = {
            ...this.form,
            calories: Number(this.form.calories),
            duration: Number(this.form.duration),
            tags,
            storyboard: this.form.type === WORKOUT_TYPES.ROUTE ? this.formatStoryboard.reduce((acc, item) => {
              if (item.fileName) {
                acc[item.code] = item.fileName;
              }
              return acc;
            }, {}) : null,
          };
          delete data.levelTags;
          delete data.purposeTags;
          delete data.otherTags;
          const method = this.isEditMode ? this.updateItem : this.createItem;
          method({ id, data })
            .then((resp) => {
              if (id) {
                this.$emit('update:visible', false);
              } else {
                this.setItemId(resp.id);
                this.fetchItem();
              }
            }).catch(() => {});
        }
      });
    },
  },
  watch: {
    item: {
      handler() {
        this.fillForm();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.loaded-image {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.six-picture {
  width: 300px;
  margin-left: auto;
  margin-right: auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 8px;
  background: black;
  border-radius: 12px;
  padding: 12px;
  &-item {
    &__image {
      position: relative;
      width: 100%;
      height: 52px;
      margin-bottom: 6px;
      border-radius: 12px;
      background-position: center;
      background-size: cover;
      background-color: #939393;
      &-close {
        color: white;
        font-size: 24px;
        line-height: 24px;
        position: absolute;
        right: -8px;
        top: -10px;
        cursor: pointer;
        background-color: black;
        border-radius: 50%;
      }
    }

    &__title {
      text-align: center;
      color: white;
      font-size: 10px;
    }
  }
}
</style>
